import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { CREATE_EXERCISE } from '../redux/exercisesReducer'
import GapEditor from './GepEditor'

interface Props {
  toggleModal: () => void
}

const FillTheGapQuestion = ({ toggleModal }: Props) => {
  const editableRef = useRef<HTMLDivElement>(null)
  const dispatch = useDispatch()
  const { lessonPlanId } = useParams()

  const handleSubmit = () => {
    dispatch(
      CREATE_EXERCISE({
        question: editableRef.current?.innerHTML || '',
        answer: editableRef.current?.innerHTML || '',
        lessonPlanId: Number(lessonPlanId),
        question_type: 'fill_gap'
      })
    )
    toggleModal()
  }

  return (
    <>
      <div className="h-4" />
      <div>
        <div className="text-14 font-medium">Answer</div>
        <div className="h-2" />
        <GapEditor editableRef={editableRef} />
      </div>
      <div className="h-6" />
      <div className="flex justify-end">
        <button onClick={handleSubmit} className="bg-slateGray text-white rounded-lg px-4 py-2">
          Add Exercise
        </button>
      </div>
    </>
  )
}

export default FillTheGapQuestion
